import fetch from '../../config/fetch';

/**
 * 登陆
 */
export const login = data => fetch('/operator/login', data, 'POST');

/**
 * 退出
 */
export const signout = data => fetch('/operator/logout', data, 'GET');

/**
 * 修改密码
 */
export const editPassword = data => fetch('/operator/modify-password', data, 'POST');

/**
 * 登录获取菜单
 */
export const getMenuList = data => fetch('/menu/auth/' + data, {}, 'POST');

/**
 * 登录获取菜单/home/count
 */
export const getHomeCount = data => fetch('/home/count', data, 'POST');



// WEBPACK FOOTER //
// ./src/api/login/login.js